module.exports = __webpack_public_path__ + "static/media/user-lock.4da11be5.svg";